<template>
    <div class="main-content main-content--wizzard">
        <h1 v-translate>
            Plan new activity
        </h1>
        <div class="steps__container">
            <div class="steps__step" v-bind:class="{'steps__step--current' : stepLocation == 'step-1'}">
                <strong v-translate>Activity info</strong>
            </div>
            <div class="steps__step" v-bind:class="{'steps__step--current' : stepLocation == 'step-2'}">
                <strong v-translate>Result</strong>
            </div>
            <div class="steps__step" v-bind:class="{'steps__step--current' : stepLocation == 'step-3'}">
                <strong v-translate>Date</strong>
            </div>
            <div class="steps__step" v-bind:class="{'steps__step--current' : stepLocation == 'step-4'}">
                <strong v-translate>Reminder</strong>
            </div>
        </div>

        <plan-activity-step-one :parent_activity="activity" v-if="stepLocation == 'step-1'" @advance="changeStep"/>

        <plan-activity-step-two :parent_activity="activity" v-if="stepLocation == 'step-2'" @advance="changeStep"/>

        <plan-activity-step-three :parent_activity="activity" v-if="stepLocation == 'step-3'" @advance="changeStep"/>

        <plan-activity-step-four :parent_activity="activity" v-if="stepLocation == 'step-4'" @advance="changeStep"
                                 @add="addActivity"/>


    </div>
</template>

<script>
    import {mapActions} from "vuex";
    import ChooseDate from "./popups/ChooseDate";
    import PlanActivityStepOne from "../components/plan-activity/PlanActivityStepOne";
    import PlanActivityStepTwo from "../components/plan-activity/PlanActivityStepTwo";
    import PlanActivityStepThree from "../components/plan-activity/PlanActivityStepThree";
    import PlanActivityStepFour from "../components/plan-activity/PlanActivityStepFour";
    import axios from "axios";
    import PackageFeatureRequired from "../mixins/PackageFeatureRequired";

    export default {
        components: {PlanActivityStepFour, PlanActivityStepThree, PlanActivityStepTwo, PlanActivityStepOne},
        mixins: [PackageFeatureRequired('plan_your_success_day')],
        data() {
            return {
                stepLocation: 'step-1',
                choose_date: ChooseDate,
                activity: {
                    name: '',
                    description: '',
                    category: '',
                    subcategory: '',
                    expected_result: '',
                    measure: '',
                    date: '',
                    reminders: [{
                        reminder_data: {
                            via: 'email',
                            when: 1,
                            what: 'days'
                        }
                    }],
                },
            }
        },
        methods: {
            ...mapActions([
                'openPopup'
            ]),
            changeStep: function (step) {
                this.stepLocation = step;
            },
            addActivity: async function () {
                let fixed_reminders = []
                for (let i = 0; i < this.activity.reminders.length; i++) {
                    fixed_reminders.push(this.activity.reminders[i].reminder_data)
                }
                this.activity.reminders = fixed_reminders
                await axios.post('/api/navigator/activities/', this.activity)
                this.$router.push({name: 'my-success-day-activities'})
            }
        }
    }
</script>